<!--
  ~ Copyright (C) 2023 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="share-link-container">
  <div class="share-link-container-inner">
    <div class="share-link-heading">
      <div class="large title">Share</div>

      <button
        mat-icon-button
        tabindex="0"
        [attr.aria-label]="'translations.global.ariaLabels.closeFolioHelpModal' | transloco"
        (click)="closeDialog()"
      >
        <svg class="close-svg svg svg-icon" aria-hidden="true">
          <use ogSvgUnify="assets/sprite/sprite.svg#close"></use>
        </svg>
      </button>
    </div>

    <div class="share-socials-items-container">
      <div class="share-social-items-list">
        <div *ngFor="let socialItem of socialShareItems" class="share-social-item">
          <button
            tabindex="0"
            type="button"
            [attr.aria-label]="
              'translations.global.ariaLabels.tapToShareLinkInSocial'
                | transloco
                  : {
                      url: shareUrl,
                      social: socialItem.title,
                    }
            "
            class="social-item-button {{ socialItem.name }}"
            (click)="shareAction(socialItem.name)"
          >
            <svg class="svg" role="img" [attr.aria-label]="socialItem.name + ' icon'" aria-hidden="true">
              <use ogSvgUnify="assets/sprite/sprite.svg#{{ socialItem.name }}"></use>
            </svg>
          </button>
          <div class="social-item-title small">{{ socialItem.title }}</div>
        </div>
      </div>
    </div>

    <div class="copy-share-link-container">
      <div class="share-input">
        <input type="text" id="copyLink" [value]="shareUrl" readonly />
        <button
          tabindex="0"
          class="copy-btn"
          mat-flat-button
          [attr.aria-label]="'translations.global.ariaLabels.tapToCopyLink' | transloco"
          (click)="shareAction(socialShareType.COPY)"
          color="primary"
        >
          {{ 'translations.global.button.copy' | transloco }}
        </button>
      </div>
    </div>
  </div>
</div>
